import { ArrowUpRight } from "lucide-react";
import { getBookingUrl, trackEvent } from "@/lib/constants";

export const ExperienceButton = ({
  id,
  children = "Book My Complimentary Session",
  variant = "red",
  prominent = false,
  className = ""
}) => {
  const styles =
    variant === "red"
      ? "bg-rest-red text-white hover:bg-[#ff4d5a]"
      : "bg-white text-black hover:bg-zinc-200";
  const sizing = prominent ? "px-9 py-5 text-sm" : "px-7 py-4 text-xs";
  return (
    <a
      href={getBookingUrl()}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() => trackEvent("booking_button_click", { button_id: id })}
      aria-label="Book your complimentary first recovery session at Rest Recovery Wellness"
      data-testid={id}
      className={`group inline-flex cursor-pointer items-center gap-3 font-mono uppercase tracking-[0.2em] transition-colors duration-300 ${sizing} ${styles} ${className}`}
    >
      {children}
      <ArrowUpRight className={`${prominent ? "h-5 w-5" : "h-4 w-4"} transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5`} />
    </a>
  );
};
